<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li>
                    <router-link to="/layout/index">首页</router-link>
                </li>
                <li>
                    <router-link to="/layout/institution-list">会员风采</router-link>
                </li>
                <li>
                    <router-link :to="`/layout/institution-list?page=${page}`">驻京办风采</router-link>
                </li>
                <li class="currentNode"><a>驻京机构详情</a></li>
            </ul>
            <div class="page-main">
                <h3>{{ title }}</h3>
                <el-divider></el-divider>
                <div class="content-detail" v-html="content"></div>
                <h3>工作动态</h3>
                <el-divider></el-divider>
                <el-table stripe :data="tableData" style="width: 100%" :show-header="false" class="stripe-table">
                    <el-table-column label="内容">
                        <template slot-scope="scope">
                                <a class="table_a" @click="goDetail(scope.row)">
                                    <p class="ellipsis_one">
                                        <span class="dot"></span>
                                        <span>{{ scope.row.Title }}</span>
                                    </p>
                                </a>
</template>
                    </el-table-column>
                    <el-table-column prop="UpdateTime" label="日期" width="120">
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
                <!-- <p>协助办事处领导抓好机关自身建设和行政管理，办理领导交办的事项；承担党组会议和主任办公会议决定事项的督办及理论学习中心组的秘书工作；负责电、机要、档案、保密工作；负责机关财务核算管理和后勤保障工作；负责办事处（含原省政府驻山西、天津、沈阳办事处）国有资产的运营和监督管理工作；负责安全联席会议单位的安全管理工作。联系各市政府驻京办事机构</p>
                    <p class="introduction-title">科学教育及其他社会事业</p>
                    <p>数据来源:《北京市2023年国民经济和社会发展统计公报》(数据发布时间:2024年3月21日)</p>
                    <p>教育:2023年全年研究生教育招生15.2万人，在学研究生45.5万人，毕业生12.1万人。普通高等学校招收本专科学生17.6万人，在校生61.8万人，毕业生15.4万人。全市成人本专科招生3.0万人，在校生7.6万人，毕业生3.0万人。2023年全年普通高中招生8.0万人，在校生21.7万人，毕业生5.9万人。普通初中招生13.5万人，在校生37.1。</p>
                    <p class="introduction-title">城市建设</p>
                    <p>数据来源:《北京市2023年国民经济和社会发展统计公报》(数据发布时间:2024年3月218)</p>
                    <p>2023年年末全市公路里程22433.2公里，比上年末增加70.4公里。其中高速公路里程1211.1公里，增加14.8公里。年末城市道路里程6256公里，比上年末增加47公里。2023年年末公共汽电车运营线路1285条，比上年末减少6条;运营线路长2023年年末公共汽电车运营线路1285条，比上年末减少6条;运营线路长2023年年末公共汽电车运营线路1285条，比上年末减少6条;运营线路长。</p> -->
            </div>
        </div>
    </div>
</template>

<script>
import {
    getPlolicyDetail,
    getZhujingbanWork,
} from '@services/indexService.js';
export default {
    name: '',
    data() {
        return {
            detailId: '',
            page: '',
            publishTime: '',
            title: '',
            subTitle: '',
            content: '',
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
        };
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page ? this.$route.query.page : 1;
        this.getPlolicyDetail(this.detailId);
        this.getZhujingbanWork();
    },
    methods: {
        getPlolicyDetail(id) {
            let params = {
                id: id,
            };
            getPlolicyDetail(params).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    // this.subTitle = res.Data.SubTitle;
                    this.content = res.Data.Content;
                } else {
                    this.$message.error('驻京机构详情请求失败');
                }
            });
        },
        getZhujingbanWork() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                id: this.detailId,
            };
            getZhujingbanWork(params).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = [...res.Data];
                    this.total = res.Count;
                } else {
                    this.tableData = [];
                    this.$message.error('工作动态求失败');
                }
            });
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getGongxiangZhujingban();
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/institution-work-detail',
                query: {
                    id: data.Id,
                    officeId: this.detailId,
                }
            });
            window.open(newUrl.href, '_blank');
        }
    },
};
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
</style>